import { render } from "./Promos.vue?vue&type=template&id=a43a530a&scoped=true&ts=true"
import script from "./Promos.vue?vue&type=script&lang=ts"
export * from "./Promos.vue?vue&type=script&lang=ts"

import "./Promos.vue?vue&type=style&index=0&id=a43a530a&scoped=true&lang=css"

import exportComponent from "/var/www/prod/LVCManagerWebsitePerso/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43a530a"]])

export default __exports__